<script>
  export default {
    components: {
      TabContent: async () => {
        let AsyncView = null
        const AsyncHandler = () => ({
          component: AsyncView,
          loading: require('@views/_loading.vue').default,
          delay: 400,
          error: require('@views/_timeout.vue').default,
          timeout: 10000,
        })

        return {
          functional: true,
          render(h, { data, children }) {
            AsyncView = data.attrs.component()
            return h(AsyncHandler, data.attrs['component-data'] ? JSON.parse(JSON.stringify(data.attrs['component-data'])) : {}, children)
          },
        }
      },
    },
    props: {
      items: {
        type: Array,
        default: () => ([]),
      },
    },
    computed: {
      activeTab () {
        let tab = null
        for (const item of this.items) {
          if (this.$route.name === item.route.name && this.$route.params.tab === item.route.params.tab) {
            tab = item
            break
          }
        }
        return tab
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="tabs">
    <ul class="nav nav-tabs">
      <li v-for="(item, index) in items" :key="`tab-${index}`" class="nav-item">
        <router-link
          v-if="item.route"
          class="nav-link"
          :class="{ 'active': $route.name === item.route.name && $route.params.tab === item.route.params.tab }"
          :to="item.route"
        >
          {{ item.title }}
        </router-link>
        <a v-else class="nav-link">{{ item.title }}</a>
      </li>
    </ul>
    <div v-if="activeTab" class="tab-content mt-3">
      <div class="tab-pane active">{{activeTab.title}}
        <TabContent :key="activeTab.title" :component="activeTab.component" :component-data="activeTab.componentData"/>
      </div>
    </div>
  </div>
</template>
